import { type Dispatch, type SetStateAction, useContext, useEffect, useState } from "react";

import { AppContext } from "@/models/AppStateProvider";
import { FeedContext } from "@/models/FeedContextProvider";
import { useReactiveSelectQuery } from "@/models/hooks/useReactiveSelectQuery";
import { fetchFeedCommandAliasesQuery } from "@/models/repositories";
import ClassicFeed from "./classic/ClassicFeed";
import DriverCentricFeed from "./driver-centric/DriverCentricFeed";

export default function Feed({ setRenderToggle }: { setRenderToggle: Dispatch<SetStateAction<string>> }) {
  const { currentFeed } = useContext(FeedContext);
  const [currentFeedDate, setCurrentFeedDate] = useState<Date | null>(null);
  const { flags } = useContext(AppContext);

  useEffect(() => {
    setCurrentFeedDate(() => new Date());
  }, [currentFeed?.id]);

  const aliasChannelDetails =
    useReactiveSelectQuery(
      fetchFeedCommandAliasesQuery,
      [currentFeed.id],
      "Workspace:index:fetchFeedCommandAliasesQuery",
    ) ?? [];

  const aliasAccount = aliasChannelDetails?.length > 0 ? aliasChannelDetails[0] : null;

  if (flags.newDesign) {
    return (
      <DriverCentricFeed
        currentFeedDate={currentFeedDate}
        setRenderToggle={setRenderToggle}
        aliasAccount={aliasAccount}
        feed={currentFeed}
      />
    );
  }

  return <ClassicFeed currentFeedDate={currentFeedDate} setRenderToggle={setRenderToggle} />;
}
